import { useRef, useState } from "react"

import { CuentasYResultados } from "@/componentes/administracion/CuentasYResultados"
import { FlujoCaja } from "@/componentes/administracion/FlujoCaja"
import { Exportar } from "@/componentes/exportar/Exportar"
import {
  consultaDe,
  nombrePeriodo,
  type PeriodoAdmin,
  periodoInicial,
  SelectorPeriodoAdmin,
} from "@/componentes/ui/SelectorPeriodoAdmin"
import { ContenidoInforme } from "@/paginas/interno/InformeGastos"

/**
 * Los reportes gerenciales de la administración, en UNA entrada (28/10, minuta del 27/10,
 * puntos 1, 2 y 3). Un solo período para todo: semana por omisión, 15, 30, 60 días o mes.
 *
 * ⚠ **Cada cifra se dice UNA vez** (28/10, «estamos redundando»): el reporte de cuentas y
 * resultados lleva el presupuesto, lo ejecutado y lo comprometido por categoría y partida;
 * el flujo de caja, lo que entró y salió de los bancos; y la composición, lo que el
 * reporte no dice —fijo contra variable y qué se compró—. El informe de gastos repetía el
 * total, lo comprometido y la tabla por categoría, y se recortó a eso.
 */
export function Reportes() {
  const [periodo, setPeriodo] = useState<PeriodoAdmin>(periodoInicial)
  const filtro = consultaDe(periodo)
  // ⚠ UN Exportar para los tres reportes: cada tabla sale como su sección (cuentas por
  // partida y por categoría, flujo por banco, composición), con el período en el subtítulo.
  const vista = useRef<HTMLElement | null>(null)
  return (
    <section ref={vista} className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <SelectorPeriodoAdmin valor={periodo} onCambiar={setPeriodo} />
        <Exportar
          titulo="Reportes de administración"
          subtitulo={`Período: ${nombrePeriodo(periodo)} · en dólares`}
          contenido={vista}
        />
      </div>
      <div className="space-y-2">
        <h2 className="text-base font-semibold">Cuentas y resultados</h2>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Por categoría y por partida: con cuánto se contaba, lo que se gastó, lo que queda por
          cancelar y lo disponible. En dólares, con la tasa del día de cada factura.
        </p>
        <CuentasYResultados filtro={filtro} />
      </div>
      <div className="space-y-2 border-t pt-4" style={{ borderColor: "var(--border)" }}>
        <h2 className="text-base font-semibold">Flujo de caja</h2>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Lo que entró y salió de los bancos del 3.0, sin las transferencias entre cuentas propias.
          Pulsa un mes del gráfico para ver todos los reportes de ese mes.
        </p>
        <FlujoCaja
          filtro={filtro}
          onElegirMes={(desde) => setPeriodo({ tipo: "MES", fecha: desde })}
        />
      </div>
      <div className="space-y-2 border-t pt-4" style={{ borderColor: "var(--border)" }}>
        <h2 className="text-base font-semibold">Composición del gasto</h2>
        <p className="text-sm" style={{ color: "var(--fg-muted)" }}>
          Lo ejecutado del período, fijo contra variable y por lo que se compró.
        </p>
        <ContenidoInforme periodo={filtro} />
      </div>
    </section>
  )
}
